import BaseClient from '../BaseClient';
import type { AxiosPromise } from 'axios';
import type {
    IntelligentInboxSettingsClientInterface,
    IntelligentInboxSettingsFormData,
    IntelligentInboxSettingsResponse,
} from './intelligentInboxSettingsClient.types';

export default class CorporateIntelligentInboxSettingsClient
    extends BaseClient
    implements IntelligentInboxSettingsClientInterface
{
    constructor(private teamId: number) {
        super();
    }

    getIntelligentInboxSettings(): AxiosPromise<IntelligentInboxSettingsResponse> {
        const url = `/api/v3/teams/${this.teamId}/intelligent-inbox-settings`;
        return this.makeCoreApiRequest(url, 'get');
    }

    updateIntelligentInboxSettings(
        data: IntelligentInboxSettingsFormData,
        extraConfig?: { cancelKey?: string | symbol }
    ): AxiosPromise<IntelligentInboxSettingsResponse> {
        const url = `/api/v3/teams/${this.teamId}/intelligent-inbox-settings`;
        return this.makeCoreApiRequest(url, 'put', data, null, extraConfig);
    }
}
